<template>
  <b-col cols="12" sm="12">
    <div>
      <b-btn class="mb-3 d-flex align-items-center text-white" :variant="isSidebarVisible ? undefined : 'info'"
        :pressed.sync="isSidebarVisible">
        <feather type="alert-circle" class="feather-sm mr-2"></feather>
        {{ isSidebarVisible ? 'Cerrar formulario' : $t("vGeocercas.verForm") }}
      </b-btn>
    </div>

    <div class="map-wrapper-scaling">
      <mapa ref="map" :options="options" @mapReference="map = $event"></mapa>
    </div>

    <panel-component id="sidebar-form" :visible.sync="isSidebarVisible">
      <div style="color: #54606f;">
        <span style="font-weight: 400;">* {{ this.$t("Gral.camposObligatorios") }}</span>
        <b-col cols="12" sm="12">
          <b-form-group>
            <label for="“nombre”">{{ this.$t("Gral.nombre") }}: <strong>*</strong></label>
            <b-form-input id="nombre" v-model="geofence.nombre" required>
            </b-form-input>
          </b-form-group>
          <div v-if="isCircleGeofence" class="row">
            <b-col cols="12" sm="6">
              <b-form-group id="input-group-2" :label="$t('Gral.medida') + ':'">
                <b-form-select id="distancia" v-model="settingsDistance.distanceUnit" :options="translateUnitDistance">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      {{ $t("vGeocercas.selectMedida") }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="“radio”">{{ this.$t("Gral.radio") }}: <strong>*</strong></label>
              <b-form-input type="number" step="0.001" min="1" max="1000" id="radioV" v-model="settingsDistance.radius">
              </b-form-input>
            </b-col>
            <b-col cols="12" sm="12" style="margin-top: -16px">
              <label for="“latitud”">{{ this.$t("Gral.latitud") }}: <strong>*</strong></label>
              <b-form-input id="latitud" type="number" step="0.00000001" max="90" min="-90" v-model="geofence.latitud">
              </b-form-input>
            </b-col>
            <b-col cols="12" sm="12">
              <label for="“longitud”">{{ this.$t("Gral.longitud") }}: <strong>*</strong></label>
              <b-form-input id="longitud" type="number" step="0.00000001" max="180" min="-180"
                v-model="geofence.longitud">
              </b-form-input>
            </b-col>
          </div>
          <div class="row">
            <b-col cols="12" sm="6">
              <label for="“pick-color”">Color: <strong>*</strong></label>
              <b-form-input id="pick-color" type="color" v-model="geofence.color">
              </b-form-input>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="“latitud”">{{ this.$t("Gral.alerta") }}: <strong>*</strong></label>
              <b-form-select v-model="geofence.alerta" :options="translateTypeAlerts" required>
                <template #first>
                  <b-form-select-option :value="null" disabled>
                    {{ $t("vGeocercas.selectAlert") }}
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
            <b-col cols="12" sm="12">
              <label for="asignarDispo2">{{ this.$t("vGeocercas.lblAsigDispo") }}:</label>
              <multiselect id="asignarDispo2" v-model="geofence.dispositivos" :options="devices" :multiple="true"
                :selectLabel="$t('vHistorico.presioneAgregar')" :selectedLabel="$t('vHistorico.seleccionado')"
                :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('Gral.escribaBuscar')"
                track-by="nombre" label="nombre">
                <span slot="noResult">{{ this.$t("vHistorico.msgBusquedaFallida") }}</span>
              </multiselect>
            </b-col>

            <b-col cols="12" style="margin-top: -20px">
              <b-btn class="mt-1 w-100 text-light" color="primary" @click="returnToGeofences">
                {{ this.$t("Gral.cancelar") }}
              </b-btn>
            </b-col>
            <b-col cols="12" style="margin-top: -20px">
              <b-btn class="mt-1 w-100 text-white" variant="info" @click="updateGeocerca">
                {{ this.$t("vGeocercas.saveGeocercas") }}
              </b-btn>
            </b-col>
          </div>
        </b-col>
      </div>
    </panel-component>
  </b-col>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from '../../../services/Crypto';
import DevicesDataService from "../../../services/DevicesDataService";
import GeocercaDataService from "../../../services/GeocercaDataService";


import Mapa from "./../../components/Map";
import Multiselect from "vue-multiselect";
import PanelComponent from './../../components/PanelComponent';

import L from 'leaflet';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';
import { generalSweetAlert } from "../../../utils/Utils";

export default {
  name: "edit-geocerca",
  components: {
    Mapa,
    PanelComponent,
    Multiselect,
  },
  data() {
    return {
      map: null,
      isSidebarVisible: false,
      options: {
        useDrawTools: false,
      },
      geofence: {},
      isCircleGeofence: true,
      settingsDistance: {
        distanceUnit: null,
        radius: "",
      },
      distanceUnit: [
        { text: "km", value: "Kilómetros." },
        { text: "metros", value: "Metros." },
      ],
      typeAlerts: [
        { text: "ambos", value: "Ambos" },
        { text: "entrada", value: "Entrada" },
        { text: "salida", value: "Salida" },
      ],
      key: '',
      devices: [],
      geofenceLayer: null,
      editableControl: null,
    }
  },
  computed: {
    translateUnitDistance() {
      return this.translateOptions(this.distanceUnit)
    },
    translateTypeAlerts() {
      return this.translateOptions(this.typeAlerts);
    }
  },
  mounted() {
    this.key = sessionStorage.getItem('key')
    this.getDevices();
    this.loadDataGeofence(this.$route.params);
    
  },

  watch: {
    // Este watcher se activará en cuanto el componente <mapa> asigne el objeto Leaflet a 'this.map'
    map(mapInstance) {
      if (mapInstance) {
        this.$nextTick(() => {
          try {
            // Verificar que el componente hijo tenga el método listo
            if (this.$refs.map && typeof this.$refs.map.renderControlEdit === 'function') {
              this.editableControl = this.$refs.map.renderControlEdit();
            } else {
              console.warn("renderControlEdit no está disponible en $refs.map");
              return;
            }

            // Si los datos de la geocerca ya existen, la renderizamos
            if (this.geofence && this.geofence.locate) {
              this.renderGeofence();
            }
          } catch (error) {
            console.error("Error al inicializar la geocerca en el mapa:", error);
          }
        });
      }
    }
  },

  methods: {
    translateOptions(values) {
      return values.map((option) => {
        if (typeof option === "object" && option.text) {
          return {
            ...option,
            text: this.$t(`vGeocercas.${option.text}`),
          };
        }
      });
    },
    /** Método para obtener todos los dispositivos. */
    async getDevices() {
      try {
        const response = await DevicesDataService.getAll();
        this.devices = await Crypto.desencriptar(response.data, this.key);
      } catch (error) {
        console.log(error);
      }
    },
    loadDataGeofence(datos) {
      if (datos.id === null || datos.id === undefined) {
        this.returnToGeofences();
        return; // Detenemos la ejecución si no hay ID
    }

      this.geofence = datos;
      this.settingsDistance.distanceUnit = datos.radio < 1000 ? 'Metros.' : 'Kilómetros.';
      this.settingsDistance.radius = this.settingsDistance.distanceUnit == 'Metros.' ? datos.radio : datos.radio / 1000

      this.isCircleGeofence = datos.locate.type === 'Point';
    },
    renderGeofence() {
      // Validación de seguridad
      if (!this.$refs.map || !this.map) {
        console.warn("El mapa aún no está listo para renderizar la geocerca.");
        return;
      }
      
      let data = {}
      if (this.geofence.locate.type == 'Point') {
        data = {
          lat: this.geofence.latitud,
          lng: this.geofence.longitud,
          radio: Math.floor(this.geofence.radio),
          color: this.geofence.color,
        }
      } else {
        data = {
          latlngs: this.geofence.locate.coordinates[0].map(coord => [coord[1], coord[0]]),
          color: this.geofence.color,
        }
      }

      this.geofence.layer = this.$refs.map.renderEntityOnMap(data);
      this.$refs.map.nuevoZoom([this.geofence.layer]);
      this.editableControl.layer.addLayer(this.geofence.layer);
      this.setupColorChangeListener();
      this.map.on(L.Draw.Event.EDITED, (event) => { this.onDrawCreated(event) });
    },

    setupColorChangeListener() {
      const pickColor = document.getElementById("pick-color");
      pickColor.addEventListener("input", this.handleColorChange, false);
    },
    handleColorChange() {
      const color = document.getElementById("pick-color").value;
      if (this.geofence.layer) {
        this.geofence.layer.setStyle({ color, fillColor: color });
      }
    },
    onDrawCreated(event) {
      const layers = event.layers;
      if (this.isCircleGeofence) {
        layers.eachLayer((layer) => {
          console.log(layer);
          this.geofence.latitud = Number.parseFloat(layer.getLatLng().lat.toFixed(8));
          this.geofence.longitud = Number.parseFloat(layer.getLatLng().lng.toFixed(8));

          this.geofence.locate.coordinates[0] = this.geofence.longitud;
          this.geofence.locate.coordinates[1] = this.geofence.latitud;

          this.setRadius(layer.getRadius());
          this.geofence.locate.properties.radius = this.geofence.radio;
        });
      } else {
        layers.eachLayer((layer) => {
          let arreglo = [];
          let posiciones = layer.getLatLngs();
          for (let i = 0; i < posiciones[0].length; i++) {
            let item = posiciones[0];
            let lng = Number.parseFloat((item[i].lng).toFixed(6));
            let lat = Number.parseFloat((item[i].lat).toFixed(6));
            arreglo.push([lng, lat]);
          }
          arreglo.push(arreglo[0]);
          this.geofence.locate.coordinates = [arreglo];
        });
      }
    },

    setRadius(radius) {
      radius = Number.parseFloat(radius.toFixed(2));
      const radio = radius < 1000 ? radius : radius / 1000;
      this.settingsDistance.radius = radio.toFixed(2);
      this.settingsDistance.distanceUnit = radius < 1000 ? 'Metros.' : 'Kilómetros.';
      this.geofence.radio = radius;
    },

    async updateGeocerca() {
      console.log('Actualizar geocerca')
      delete this.geofence.layer;
      delete this.geofence.usuario;
      this.geofence.habilitado = true;
      try {
        await GeocercaDataService.update(this.geofence, this.key);
        const accion = "Actualizó la geocerca " + this.geofence.nombre;
        this.registrarAccion(accion);
        
      } catch (error) {
        console.error(error);
        
      } finally {
        // Se deja este bloque de momento ya que encontre un bug en el back respecto a los dispositivos asignados a la geocerca
        // por tal motivo se desactiva el cuerpo del catch()
        generalSweetAlert(this.$t("vGeocercas.msgActgeo"), 'success');
        this.returnToGeofences();
      }
    },
    registrarAccion(accion) {
      let data = {
        usuario: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
        accion: accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    returnToGeofences() {
      this.$router.push("/geocercas");
    }
  },
}
</script>

<style>
/* Contenedor del mapa para que sea dinámico */
.map-wrapper-scaling {
  width: 100%;
  height: 65vh;
  /* Ocupa el 65% del alto de la pantalla */
  min-height: 500px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
}
</style>